import React, { useState } from 'react';
import EditReviewHeader from 'components/kitchen/edit-review/header';
import EditReviewFooter from 'components/kitchen/edit-review/footer';
import KitchenShiftCard from 'components/kitchen/shift-card';
import useWeeklyRosterContext from 'contexts/weekly-roster.context';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'utils/api';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { KITCHEN_ROUTE_KEYS } from 'utils/constants';
import { WEEKLY_ROSTER_PAGES } from 'utils/enum';
import moment from 'moment';

const ReviewRoster = () => {
  const { addRosterFormData, department } = useWeeklyRosterContext();
  const [searchParams] = useSearchParams();
  const start_date = searchParams.get('start_date');
  const end_date = searchParams.get('end_date');

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    const dataToServer = addRosterFormData[0];
    const days = moment(end_date).diff(moment(start_date), 'days') + 1;
    const datesInRange = Array.from({ length: days }, (_, i) =>
      moment(start_date).add(i, 'days').format('YYYY-MM-DD')
    );

    setLoading(true);
    try {
      const data = {
        department_id: department.value,
        entries: datesInRange.map((date) => ({
          date: date,
          shifts: {
            morning: dataToServer.morning,
            afternoon: dataToServer.afternoon,
            night: dataToServer.night
          }
        }))
      };
      const res = await apiService.post('kitchen/rosters/upload', {
        data,
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });
      toast(<ToastMessage type='success' message={res.data.message} />);
      navigate(`${KITCHEN_ROUTE_KEYS.WEEKLY_ROSTER}?start_date=${start_date}&end_date=${end_date}`);
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <EditReviewHeader
        title={WEEKLY_ROSTER_PAGES.REVIEW}
        start_date={start_date}
        end_date={end_date}
      />
      <div className='bg-[#FAFAFA] p-10 py-4'>
        <h4 className='font-semibold text-gray-6/90 pb-2'>{department.name} Department</h4>
        <section className='mb-[6px] bg-white rounded-t-xl border-t border-x border-[#F5F5F5] pt-6 px-[30px] pb-20'>
          <div className='bg-[#F5F5F5] rounded-xl'>
            {Object.keys(addRosterFormData[0]).map((shift, idx) => (
              <KitchenShiftCard key={idx} shift={shift} />
            ))}
          </div>
        </section>
        <EditReviewFooter
          onConfirm={handleConfirm}
          loading={loading}
          start_date={start_date}
          end_date={end_date}
        />
      </div>
    </div>
  );
};

export default ReviewRoster;
